<img @fade class="arrow" (click)="backToDetail()" src="./assets/global-position/summary/arrow-left.svg" alt="">

<div @fade class="summary-detail-container">
    <div class="container-position">
        <div class="categories" [hidden]="show">
            <ul id="autoWidth" class="cs-hidden">
                <li class="item-a" *ngFor="let item of listCategories; let i = index">
                    <div class="category" (click)="prepareInformation(i);">
                        <p class="category-name" [ngClass]="{'active': currentCategory === item.CategoryName }">
                            {{item.CategoryName}}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="left">
        <div class="big-five-container">
            <p class="tittle">{{ currentCategory }}</p>
            <div class="graphic-container">
                <div class="scoring">
                    <p class="scoring">
                        <span class="scoring-number" [ngStyle]="{'color': getColor(scoring)}">{{scoring}}</span>/10
                    </p>
                </div>
                <div class="graphic">
                    <img src="./assets/global-position/summary/scoring/{{porcent}}_porcent.png" alt="">
                    <p>Esta categoría tiene un peso del {{porcent}}% en el cálculo de tu Salud Financiera</p>
                </div>
            </div>
            <div class="big-container" tabindex="0" [ngClass]="{ 'more-of-six': kpisList.length > 5 }">
                <div class="big-five" *ngFor="let item of kpisList">
                    <div class="heart-container">
                        <div class="heart">
                            <img src="./assets/global-position/summary/scoring/heart_scoring/{{(item.Heart === 0) ? '2': item.Heart}}.svg"
                                alt="">&nbsp;&nbsp;&nbsp;
                        </div>
                        <div class="name">
                            {{ item.Description }}
                        </div>
                    </div>
                    <div class="num">{{ item.Value }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="right" >
        <div class="content-leyend">
            <div class="leyend">
                <div class="heart">
                    <img src="./assets/global-position/summary/scoring/heart_scoring/3.svg" alt="">&nbsp;&nbsp;
                    Muy bien
                </div>
                <div class="heart">
                    <img src="./assets/global-position/summary/scoring/heart_scoring/2.svg" alt="">&nbsp;&nbsp;
                    Bien
                </div>
                <div class="heart">
                    <img src="./assets/global-position/summary/scoring/heart_scoring/1.svg" alt="">&nbsp;&nbsp;
                    A mejorar
                </div>
            </div>
        </div>
        <div class="information-heart">
            <p class="aspect" *ngIf="hearts.heart3.length || hearts.heart2.length || hearts.heart1.length">Aspectos a
                destacar</p>
        </div>
        <div class="container-hearts">
            <div class="heart" *ngIf="hearts.heart3.length">
                <img src="./assets/global-position/summary/scoring/heart_scoring/3.svg" alt="">
                <div class="heart-3">
                    <div class="items" *ngFor="let item of hearts.heart3">
                        {{item.DescriptionBack}}
                    </div>
                </div>
            </div><br>
            <div class="heart" *ngIf="hearts.heart2.length">
                <img src="./assets/global-position/summary/scoring/heart_scoring/2.svg" alt="">
                <div class="heart-2">
                    <div class="items" *ngFor="let item of hearts.heart2">
                        {{item.DescriptionBack}}
                    </div>
                </div>
            </div><br>
            <div class="heart" *ngIf="hearts.heart1.length">
                <img src="./assets/global-position/summary/scoring/heart_scoring/1.svg" alt="">
                <div class="heart-1">
                    <div class="items" *ngFor="let item of hearts.heart1">
                        {{item.DescriptionBack}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-information">
        <p *ngIf="aviso" style="color: red; font-size: 12px; text-align: left;">{{ aviso }}</p>
    </div>
</div>